import React from 'react'
import styled, { css } from 'styled-components'
import { node, string, bool } from 'prop-types'

import { H4, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { borderColor } from 'styles/colors'

const Container = styled.div`
  position: static;

  & + & {
    border-top: 1px solid ${borderColor};
    padding-top: ${spacing.large};
    margin-top: ${spacing.large};

    ${media.large`
      padding-top: ${spacing.xLarge};
      margin-top: ${spacing.xLarge};
    `};

    ${media.xLarge`
      padding-top: ${spacing.xxLarge};
      margin-top: ${spacing.xxLarge};
    `};
  }
`

const Header = styled.header`
  margin-bottom: ${spacing.large};

  ${media.xLarge`
    margin-bottom: ${spacing.xLarge};
  `};
`

const Heading = styled(H4)`
  line-height: ${lineHeights.base};

  ${props =>
    props.muted &&
    css`
      opacity: 0.5;
    `}
`

const Content = styled.div`
  position: static;
`

const Price = styled.span`
  display: inline-block;
  font-weight: ${fontWeights.regular};
`

const BuySection = ({ id, heading, price, children, className, mutedHeading }) => {
  return (
    <Container id={id} className={className}>
      {heading && (
        <Header className="u-hide-medium-down">
          <Heading muted={mutedHeading}>
            <span>{heading}</span>
            {price && <Price>&nbsp;+&nbsp;{price}</Price>}
          </Heading>
        </Header>
      )}
      <Content>{children}</Content>
    </Container>
  )
}

BuySection.propTypes = {
  id: string,
  heading: string,
  price: string,
  className: string,
  mutedHeading: bool,
  children: node.isRequired
}

export default BuySection
